import React, { useEffect, useState } from 'react'
import apiClient from '../utils/apiClient'
import { Spinner } from 'react-bootstrap';
import useToast from '../hooks/userToast';
import { useParams } from 'react-router-dom';
const RedirectViewer = () => {
  const { timeStamp } = useParams();
  const [isLoading,setLoading]=useState(true);
  const {toastError,toastWarning } = useToast();
  useEffect(()=>{
    const hitUrl=async()=>{
      try {
        setLoading(true)
        const response=await apiClient.get(`/auth/image-url/${timeStamp}`)
        if(response && response.data){
          if(response.data.limit=="reached"){
            toastWarning("Url limit is reached")
          }
          else{
            window.location.href=response.data.viewerUrl
          }
        }
      } catch (error) {
        toastError("Error in redirecting to viewer")
        console.log(error);
      }
    }
    hitUrl();
  },[])
  if(isLoading){
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner className='w-44 h-44'/>
     </div>
    )
  }
}

export default RedirectViewer